/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown> }} Gateway_Spending_Cap_Amount_HelpInputs */



/**
* | output |
* | --- |
* | "Minimum €{min} (current spend this period)" |
*
* @param {Gateway_Spending_Cap_Amount_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_spending_cap_amount_help = /** @type {((inputs: Gateway_Spending_Cap_Amount_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Spending_Cap_Amount_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mindestens €${i?.min} (aktueller Verbrauch in dieser Periode)`)
	return /** @type {LocalizedString} */ (`Minimum €${i?.min} (current spend this period)`)
});